module.exports = __webpack_public_path__ + "media/images/iconEdit__inFrontOfAccent-ed3a7457e7d0fc299ecd7421d1df8a42.png";